import { Grid } from '@mui/material';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import {
  Button,
  FilterFunnel,
  Layers,
  MedicalRecords,
  ToggleGroup,
  MedicalHistoryTimeline,
  MedicalHistoryCard,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import React from 'react';
import moment from 'moment';
import componentConstants from '../../../core-utils/messages/componentConstants';
import { CSSProperties } from '@mui/material/styles';
import { Columns } from '@HomaHealth/ui-component-library/lib/_AIQ-components/molecules/MedicalTable';

export interface IPatientDetailsMedicalHistoryTimelineData {
  icon: React.JSX.Element;
  column1Label: string;
  column1Value: string;
  column2Label: string;
  column2Value: string;
  column3Label: string;
  column3Value: string;
  riskType: string;
  showColumn3: boolean;
}

export interface IPatientDetailsMedicalHistoryCardData {
  title: string;
  subTitle: string;
  columns: Columns[];
  rowsData: (string | boolean)[][];
}

export interface PatientDetailsMedicalHistoryTabProps {
  timelineData: IPatientDetailsMedicalHistoryTimelineData[];
  cardData: IPatientDetailsMedicalHistoryCardData[];
}

export const cellStyles1 = {
  color: patientAccessTheme.palette.text.mediumemphasis,
  fontSize: '14px',
  fontWeight: 500,
  align: 'left',
};

const buttonStyles: CSSProperties = {
  color: patientAccessTheme.palette.text.mediumemphasis,
  marginRight: '12px',
  fontSize: '14px',
  lineHeight: '24px',
  textTransform: 'none',
  backgroundColor: patientAccessTheme.palette.status.white,
  border: `1px solid ${patientAccessTheme.palette.grey[300]}`,
};

const PatientDetailsMedicalHistoryTab: React.FC<PatientDetailsMedicalHistoryTabProps> = ({
  timelineData,
  cardData,
}) => {
  const moleculeConstants =
    componentConstants.MOLECULES.PATIENT_DETAILS_MEDICAL_HISTORY_TAB;

  const [selectedTabName, setSelectedTabName] = React.useState<
    'left' | 'right'
  >('left');

  return (
    <>
      <Grid container style={{ margin: '26px 0px 20px 0px' }}>
        <Grid
          style={{
            width: 'fit-content',
            marginRight: selectedTabName === 'left' ? '494px' : '509px',
          }}
        >
          <Typography
            textColor={patientAccessTheme.palette.text.mediumemphasis}
            fontSize="12px"
            lineHeight="24px"
            fontType="semiBold"
          >
            {selectedTabName === 'left'
              ? moment().format(moleculeConstants.DATE_FORMAT)
              : moleculeConstants.MEDICAL_HISTORY}
          </Typography>
        </Grid>
        <Grid container style={{ width: 'fit-content', marginRight: '80px' }}>
          <Button
            variant="outlined"
            label={moleculeConstants.FITLER}
            style={buttonStyles}
            height="32px"
            width="106px"
            startIcon={<FilterFunnel height="24px" width="24px" />}
            borderRadius="4px"
          />
          <ToggleGroup
            leftValue={moleculeConstants.TIMELINE_VIEW}
            rightValue={moleculeConstants.CARD_VIEW}
            leftIcon={<Layers style={{ height: '16px', width: '16px' }} />}
            rightIcon={
              <MedicalRecords style={{ height: '16px', width: '16px' }} />
            }
            setSelectedToggle={setSelectedTabName}
            rightIconActiveStyles={{
              stroke: patientAccessTheme.palette.primary.main,
              strokeWidth: '2px',
            }}
            rightIconInactiveStyles={{}}
          />
        </Grid>
      </Grid>
      {selectedTabName === 'left' ? (
        <>
          <MedicalHistoryTimeline medicalTimeLineList={timelineData} />
        </>
      ) : (
        <>
          <MedicalHistoryCard cards={cardData} />
        </>
      )}
    </>
  );
};

export default PatientDetailsMedicalHistoryTab;
